import { useEffect, useState } from "react";
import { isPersistedStorage, requestPersistedStorage } from "../offline/persist";
import { listFlights } from "../offline/store";

function isSafari(): boolean {
  const ua = navigator.userAgent;
  return /Safari/.test(ua) && !/Chrome|Chromium|Edg/.test(ua);
}

export function StorageStatusBanner(): JSX.Element | null {
  const [persisted, setPersisted] = useState<boolean | null>(null);
  const [hasCached, setHasCached] = useState(false);

  async function refresh(): Promise<void> {
    setPersisted(await isPersistedStorage());
    // Skip the IDB read on browsers without IndexedDB (e.g. very locked-down
    // private modes, happy-dom test envs without fake-indexeddb). The banner
    // is purely advisory; on those environments we treat the cache as empty
    // so the banner stays hidden instead of throwing into an unhandled
    // rejection.
    if (typeof indexedDB === "undefined") {
      setHasCached(false);
      return;
    }
    setHasCached((await listFlights()).length > 0);
  }

  useEffect(() => { void refresh(); }, []);

  if (persisted === null || persisted === true || !hasCached) return null;

  return (
    <div role="status" className="vmc-storage-banner"
      style={{ background: "#3a2a00", color: "#ffd", padding: "8px 12px" }}>
      <strong>Persistent storage not granted</strong> — offline data may be
      cleared under disk pressure.{" "}
      {isSafari()
        ? <span>Tap <strong>Share &rarr; Add to Home Screen</strong> to keep it safe.</span>
        : (
          <button
            type="button"
            className="vmc-tbtn"
            onClick={async () => { await requestPersistedStorage(); await refresh(); }}
          >
            Grant persistent storage
          </button>
        )}
    </div>
  );
}
